export default "__VITE_ASSET__DYXa9966__"